
import Button from '../../../components/base/Button';

export default function TrustSection() {
  const trustElements = [
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Certified',
      description: 'Lic# 13121 • Level 2 Certified',
      highlight: 'Ontario Licensed'
    },
    {
      icon: 'ri-time-line', 
      title: '25+ Years Experience',
      description: 'Quarter-century of mortgage expertise',
      highlight: 'Since 1999'
    },
    {
      icon: 'ri-building-line',
      title: 'Trusted Brokerage',
      description: 'Professional mortgage brokerage services',
      highlight: 'Full Service'
    },
    {
      icon: 'ri-bank-line',
      title: 'Private Lending Access',
      description: 'Solutions for all mortgage cases',
      highlight: 'Specialized'
    }
  ];
  
  return (
    <section className="py-20 bg-dark-950 text-white border-t border-dark-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Your <span className="text-red-400">Trusted</span> Mortgage Partner
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Built on a foundation of trust, expertise, and unwavering commitment to client success. 
            Your mortgage journey deserves nothing less than excellence.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {trustElements.map((element, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-red-500 transition-colors duration-300">
                <i className={`${element.icon} text-3xl text-white`}></i>
              </div>
              <div className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-3">
                {element.highlight}
              </div>
              <h3 className="text-xl font-bold mb-2">{element.title}</h3>
              <p className="text-gray-400 text-sm">{element.description}</p>
            </div>
          ))}
        </div>
        
        {/* Brokerage logo placeholder */}
        <div className="flex justify-center items-center space-x-8 py-8 border-t border-dark-800">
          <div className="text-center">
            <div className="w-24 h-16 bg-dark-800 rounded-lg flex items-center justify-center mb-2 border border-dark-700">
              <img 
                src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/bcdcde40e3d45c7721e4a634ef58f84e.png"
                alt="Greater Golden Horseshoe Mortgages"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
            <div className="text-xs text-gray-500">Licensed Brokerage</div>
          </div>
          
          <div className="text-center">
            <div className="text-3xl font-bold text-red-400 mb-1">Lic# 13121</div>
            <div className="text-sm text-gray-400">Licensed Mortgage Agent</div>
          </div>
          
          <div className="text-center">
            <div className="text-3xl font-bold text-red-400 mb-1">Level 2</div>
            <div className="text-sm text-gray-400">Certified Professional</div>
          </div>
        </div>
        
        {/* Final CTA */}
        <div className="text-center pt-8">
          <a 
            href="https://calendly.com/tmonteiro-mortgagealliance/30min"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="primary" size="lg" className="text-base sm:text-lg px-4 sm:px-8 py-3 sm:py-4 w-full sm:w-auto">
              <i className="ri-calendar-check-line mr-2"></i>
              <span className="hidden xs:inline">Book Your Consultation Today</span>
              <span className="xs:hidden">Book Consultation</span>
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
